import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import SalarDeUyuni from "../assets/img/Blogs/SouthAmerica/SalarDeUyuni.jpg";
import RioDeJaneiro from "../assets/img/Blogs/SouthAmerica/RioDeJaneiro.jpg";
import Patagonia from "../assets/img/Blogs/SouthAmerica/Patagonia.jpg";
import MachuPicchu from "../assets/img/Blogs/SouthAmerica/MachuPicchu.jpg";
import AmazonRainforest from "../assets/img/Blogs/SouthAmerica/AmazonRainforest.jpg";

const SouthAmerica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap southAmericaBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>South America</h2>
                  <p>
                    South America is a continent of breathtaking landscapes,
                    ancient civilizations, vibrant cities, and diverse cultures.
                    From lush jungles to soaring mountains and colonial towns,
                    here are the top 5 destinations that promise unforgettable
                    experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={MachuPicchu} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2> Machu Picchu, Peru</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Sky-high ruins, sacred stones, and mist-wrapped mystery.
                    </p>
                  </div>
                  <p>
                    Hidden high in the Andes Mountains, Machu Picchu is a
                    15th-century Incan citadel and one of the New Seven Wonders
                    of the World. Hike the Inca Trail or take a scenic train
                    from Cusco to reach this archaeological wonder. The ruins
                    are surrounded by lush cloud forests and stunning mountain
                    views.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Sun Gate (Inti Punku) - the iconic viewpoint at sunrise.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={RioDeJaneiro} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Rio de Janeiro, Brazil</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Sea, samba, and soaring peaks beneath Christ’s embrace.
                    </p>
                  </div>
                  <p>
                    A vibrant coastal city famous for its beaches, samba, and
                    towering granite peaks. Home to the world-renowned Carnival
                    Festival, the city buzzes with energy year-round. Relax on
                    Copacabana Beach or hike up to Sugarloaf Mountain.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Christ the Redeemer - one of the world’s most iconic
                        statues.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={Patagonia} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Patagonia, Argentina & Chile</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Rugged peaks, roaring winds, and raw, untamed beauty.</p>
                  </div>
                  <p>
                    A vast, rugged region known for dramatic glaciers, turquoise
                    lakes, and snow-capped peaks. Perfect for trekking, wildlife
                    watching, and landscape photography. Explore Torres del
                    Paine National Park and Perito Moreno Glacier.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Fitz Roy Mountain - a striking peak ideal for
                        adventurous hikes.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={AmazonRainforest} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> Amazon Rainforest, Brazil (and bordering countries)</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Endless green, flowing life, and Earth’s living lungs.
                    </p>
                  </div>
                  <p>
                    The world’s largest tropical rainforest, teeming with unique
                    biodiversity and river systems. Visit from Manaus to explore
                    canopy walkways, jungle lodges, and indigenous communities.
                    Cruise down the Amazon River and spot exotic wildlife like
                    pink dolphins.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Meeting of the Waters - where the Rio Negro and Amazon
                        River meet.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={SalarDeUyuni} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> Salar de Uyuni, Bolivia</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Mirror skies, endless salt, and surreal stillness.</p>
                  </div>
                  <p>
                    The world’s largest salt flat, Salar de Uyuni becomes a
                    mirror-like wonder during the rainy season. Its surreal,
                    otherworldly landscape is ideal for photography and
                    stargazing. Take a 4x4 tour through cacti-covered islands
                    and colorful lagoons.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Incahuasi Island - a cactus-studded island in the middle
                        of the salt flats.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={MachuPicchu} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2> Start planning your South America adventure today!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default SouthAmerica;
